<template>
    <v-row align="baseline">
        <template v-for="{ term, desc } in items">
            <v-col cols="3" md="2" :key="`${term}-term`"> {{ term }}</v-col>
            <v-col cols="9" md="10" :key="`${term}-desc`"> {{ desc }} </v-col>
        </template>
    </v-row>
</template>

<script>
import { initAuctionAuthor } from "@/assets/inits";
export default {
    props: {
        author: { type: Object, default: initAuctionAuthor },
    },
    computed: {
        items() {
            let country = "";
            if (this.author?.country?.ko) country += this.author?.country?.ko;
            if (this.author?.country?.en) {
                if (country) country += `(${this.author?.country?.en})`;
                else country += this.author?.country?.en;
            }

            let { bornAt, diedAt } = this.author || {};
            if (bornAt) bornAt = this.$dayjs(bornAt).format("YYYY.MM.DD");
            if (diedAt) diedAt = this.$dayjs(diedAt).format("YYYY.MM.DD");

            return [
                { term: "국가", desc: country },
                { term: "생년월일", desc: bornAt || "-" },
                { term: "생몰월일", desc: diedAt || "-" },
            ];
        },
    },
};
</script>

<style>
</style>